import { FiYoutube } from 'react-icons/fi'
import { MdClose } from 'react-icons/md'
import { RiCalendarLine } from 'react-icons/ri'
import { Link } from 'react-router-dom'
import {
  Card,
  CardTitle,
  CardWrapper,
  CloseButton,
  Container,
  ImageHeader,
  InfoCourseWrapper,
  MostRecommended,
  Wrapper,
  SubscriptionOffer,
} from './styles'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/modules/rootReducer'

interface ModuleAndCourseProps {
  icon: string
  name: string
  discount: number
  permanentLink: string
  _id: string
  qtd_videos: number
  qtd_pdf: number
}

interface ModalFreemiumProps {
  module: ModuleAndCourseProps
  course: ModuleAndCourseProps
  subscription: boolean
  setOpenModal: any
}

const ModalFreemium: React.FC<ModalFreemiumProps> = ({
  module,
  course,
  subscription,
  setOpenModal,
}) => {
  const { isDarkMode } = useSelector((state: RootState) => state.theme)

  return (
    <Container>
      <Wrapper>
        {!subscription ? (
          <div>
            <div style={{ textAlign: 'end' }}>
              {' '}
              <CloseButton id="fechar" onClick={() => setOpenModal(false)}>
                <MdClose id="close" size={30} />{' '}
              </CloseButton>{' '}
            </div>
            <h1 style={{ textAlign: 'center' }}>Este é só o início!</h1>
            <h2 style={{ textAlign: 'center' }}>
              Para garantir seu <b>acesso completo e benefícios exclusivos</b>, selecione uma de
              nossas ofertas abaixo.
            </h2>
            <CardWrapper>
              <Link
                key={module._id}
                to={{ pathname: `${module.permanentLink}?utm_source=freemium` }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Card isDarkMode={isDarkMode} isPromo={module.discount ? true : false}>
                  <ImageHeader>
                    {module.discount ? (
                      <span className="discount" style={{ marginTop: '1rem', marginRight: 'auto' }}>
                        <p>{module.discount}%OFF</p>
                      </span>
                    ) : (
                      <div />
                    )}
                    <img loading="lazy" src={module.icon} width={130} height={130} alt="Logo" />
                  </ImageHeader>
                  <CardTitle>
                    <b>{module.name.substr(0, 150) + `${module.name.length > 150 ? '...' : ''}`}</b>
                  </CardTitle>
                  <InfoCourseWrapper>
                    {module.qtd_videos ? (
                      <span>
                        <FiYoutube />{' '}
                        <span className="qtd">{`${module.qtd_videos.toFixed(0)} Videos`}</span>
                      </span>
                    ) : (
                      ''
                    )}
                    {module.qtd_videos && module.qtd_pdf ? <>&bull;</> : ''}
                    {module.qtd_pdf ? (
                      <span>
                        <RiCalendarLine />{' '}
                        <span className="qtd">{`${module.qtd_pdf.toFixed(0)} PDFs`}</span>
                      </span>
                    ) : (
                      ''
                    )}
                  </InfoCourseWrapper>
                </Card>
              </Link>
              <Link
                target="_blank"
                key={course._id}
                to={{ pathname: `${course.permanentLink}?utm_source=freemium` }}
                rel="noopener noreferrer"
              >
                <Card isDarkMode={isDarkMode} isPromo={course.discount ? true : false}>
                  <MostRecommended>Mais indicado</MostRecommended>
                  <ImageHeader>
                    {course.discount ? (
                      <span className="discount" style={{ marginTop: '1rem', marginRight: 'auto' }}>
                        <p>{course.discount}%OFF</p>
                      </span>
                    ) : (
                      <div />
                    )}
                    <img loading="lazy" src={course.icon} width={130} height={130} alt="Logo" />
                  </ImageHeader>
                  <CardTitle>
                    <b>{course.name.substr(0, 150) + `${course.name.length > 150 ? '...' : ''}`}</b>
                  </CardTitle>
                  <InfoCourseWrapper>
                    {course.qtd_videos ? (
                      <span>
                        <FiYoutube />{' '}
                        <span className="qtd">{`${course.qtd_videos.toFixed(0)} Videos`}</span>
                      </span>
                    ) : (
                      ''
                    )}
                    {course.qtd_videos && course.qtd_pdf ? <>&bull;</> : ''}
                    {course.qtd_pdf ? (
                      <span>
                        <RiCalendarLine />{' '}
                        <span className="qtd">{`${course.qtd_pdf.toFixed(0)} PDFs`}</span>
                      </span>
                    ) : (
                      ''
                    )}
                  </InfoCourseWrapper>
                </Card>
              </Link>
            </CardWrapper>
          </div>
        ) : (
          <SubscriptionOffer>
            <div style={{ textAlign: 'end' }}>
              {' '}
              <CloseButton id="fechar" onClick={() => setOpenModal(false)}>
                <MdClose id="close" size={30} />{' '}
              </CloseButton>{' '}
            </div>
            <h1 style={{ textAlign: 'center' }}>Este é só o início!</h1>
            <h2>
              Para garantir <b>acesso completo e benefícios exclusivos</b>, confira as nossas
              ofertas de planos de assinatura para acessar esse e outros cursos
            </h2>
            <div className="offer-container">
              <Link
                target="_blank"
                to={{ pathname: `https://assinaturas.direcaoconcursos.com.br/?utm_source=trial` }}
                rel="noopener noreferrer"
              >
                CONFERIR OFERTAS
              </Link>
            </div>
          </SubscriptionOffer>
        )}
      </Wrapper>
    </Container>
  )
}

export default ModalFreemium
